import { app } from '../../app.module'
/**
 * 動画秒数範囲フォームコンポーネント
 * @class DurationRangeFormComponentCtrl
 */
class DurationRangeFormComponentCtrl {
  private scope: ng.IScope
  private rootScope
  // 選択した動画秒数範囲
  private durationValue: string[]
  // 動画秒数範囲
  private durationRanges: {
    name: string
    value: string
  }[]

  constructor($rootScope, $scope) {
    this.rootScope = $rootScope
    this.scope = $scope
    // 動画秒数範囲の初期化
    this.durationRanges = this.initDurationRange()

    // 動画秒数範囲が指定される場合は、セット
    if (this.rootScope.durationFilter) {
      this.durationValue = this.rootScope.durationFilter
    }
  }

  /**
   * 動画秒数範囲を変更の処置
   * @param {string[]} selectedValue 選択した動画範囲
   */
  public changeDurationRange() {
    if (this.durationValue === undefined || this.durationValue.length === 0) {
      this.durationValue = null
    }

    if (this.rootScope.durationFilter === this.durationValue) {
      return
    }

    this.rootScope.durationFilter = this.durationValue
    // 検索動画秒数が変更される場合、フィルタリング
    this.scope.$emit('changeFilterData', {
      type: 'durationRangeFilter',
      value: this.durationValue,
    })
  }

  /**
   * 動画秒数範囲の初期化
   * @private
   * @returns {string[]} 動画秒数範囲
   */
  private initDurationRange() {
    return [
      {
        value: '300',
        name: '5分以上',
      },
      {
        value: '180-299',
        name: '3分 - 5分',
      },
      {
        value: '60-179',
        name: '1分 - 3分',
      },
      {
        value: '30-59',
        name: '30秒 - 1分',
      },
      {
        value: '0-29',
        name: '30秒未満',
      },
    ]
  }
}
app.component('durationRangeForm', {
  template: require('./duration-range-form.pug')(),
  controller: DurationRangeFormComponentCtrl,
})
